import * as React from 'react';
import { InputGroup } from 'react-bootstrap';
import {
  Entity,
  Field,
  FieldId,
  FieldType,
  getRowKey,
  getRowLabel,
  Option,
  PersistenceType,
  Row,
} from 'gossamer-unified';
import { Dropdown } from 'gossamer-front-end';

export const addControlColumn = <T extends Row>(
  entity: Entity<T>,
  id: FieldId,
  seq: number,
  evaluateFrontEndIn: (data: T) => string,
  render: React.FC<{ value: string }>,
) => {
  (entity.fields as Record<string, Field>)[id] = {
    seq,
    type: FieldType.Text,
    persistence: PersistenceType.FrontEndOnly,
    label: '',
    editable: false,
    listColumn: true,
    sortable: false,
    evaluateFrontEndIn,
    renderUneditable: render,
  };
};

const recentSelections: Record<string, Option[]> = {};
const MAX_RECENT_SELECTIONS = 20;

export const applyRecentSelection = <T extends Row>(
  entity: Entity<T>,
  rows: T[],
  onRowClick?: (keyValue: string) => void,
) =>
  onRowClick
    ? (keyValue: string) => {
        console.log('inside rowClick generated from applyRecentSelection', keyValue);
        recentSelections[entity.id] = recentSelections[entity.id] || [];
        const selectedRow = rows.find((row) => getRowKey(entity, row) === keyValue);
        const label = getRowLabel(entity, 'Static', selectedRow);
        const index = recentSelections[entity.id].findIndex((option) => option.id === keyValue);
        if (index > -1) {
          // if selected item is already in list then remove it
          recentSelections[entity.id].splice(index, 1);
        }
        recentSelections[entity.id].unshift({
          id: keyValue,
          label,
        });
        if (recentSelections[entity.id].length > MAX_RECENT_SELECTIONS) {
          recentSelections[entity.id].pop();
        }
        onRowClick(keyValue);
      }
    : null;

interface RecentSelectionsDropdownProps<T extends Row> {
  entity: Entity<T>;
  onRecentSelectedReused: (keyValue: string) => void;
}

export const RecentSelectionsDropdown = <T extends Row>(props: RecentSelectionsDropdownProps<T>): React.JSX.Element => {
  if (!recentSelections[props.entity.id]) {
    return <></>;
  }
  return (
    <InputGroup size="sm" className="mb10px recentSelections">
      <InputGroup.Text>Recent Selections</InputGroup.Text>
      <Dropdown
        clearOnSelection={true}
        mandatory={false}
        onItemSelected={props.onRecentSelectedReused}
        options={recentSelections[props.entity.id]}
        value=""
      />
    </InputGroup>
  );
};
